import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopyFsm = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#4A5666",
		strokeWidth: 1.174,
		transform: "translate(.661 .391)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 14.87,
			height: 14.87,
			y: 3.348,
			rx: 1.565
		}), /* @__PURE__ */ _jsx("path", { d: "M16.587.609c.864 0 1.565.7 1.565 1.565v11.739c0 .864-.7 1.565-1.565 1.565h-1.718v1.174c0 .865-.7 1.565-1.565 1.565H1.565c-.864 0-1.565-.7-1.565-1.565V4.913c0-.864.7-1.565 1.565-1.565H2.5L2.5 2.174c0-.865.7-1.565 1.565-1.565z" })]
	})
});
export default SvgCopyFsm;
